import React from "react";
import { style } from "typestyle";

// @ts-ignore
import * as MarkdownIt from "markdown-it";

interface IProps {
  text: string;
}

export default function Markdown(props: IProps) {
  return (
    <div
      className={style({
        $nest: {
          "&>h1, &>h2, &>h3, &>h4, &>h5, &>h6, &>em": {
            fontWeight: "bold",
          },
          "&>ul": {
            margin: "8px 0",
            $nest: {
              "&>li": {
                fontSize: "14px",
                lineHeight: "20px",
                listStyleType: "none",
                $nest: {
                  "&:before": {
                    content: '"— "',
                  },
                },
              },
            },
          },
        },
      })}
      dangerouslySetInnerHTML={{ __html: new MarkdownIt().render(props.text) }}
    />
  );
}
